const _ = require('underscore');
const Backbone = require('backbone');
Backbone.Mutators = require('Backbone.Mutators');
Backbone.SingletonModel = require('./singleton-model.js');

module.exports = Backbone.SingletonModel.extend({
  _has(key) {
    return this._get(key) !== undefined;
  },
  _get(key) {
    return this.attributes[key];
  },
  jsonAttributes: null,
  toJSON(options) {
    const attributes = Backbone.Mutators.prototype.toJSON.call(this, options);
    let isSaving, isTransient;

    _.each(
      attributes,
      _.bind(function(value, key) {
        const mutator = this.mutators[key];

        // remove transient mutators
        if (_.isObject(mutator) === true) {
          isSaving = this.isSaving ? this.isSaving(options, mutator, key) : _.has(options || {}, 'emulateHTTP');
          isTransient = mutator.transient;
          if (isSaving && isTransient) {
            delete attributes[key];
          }
        } else if (value instanceof Backbone.Collection) {
          // serialize collections
          if (!value.isEmpty()) {
            const model = value.first();
            attributes[`${key.slice(0, -1)}_${model.idAttribute}s`] = value.map(model => model.id);
          }
          delete attributes[key];
        } else if (value instanceof Backbone.Model) {
          // serialize models
          if (!value.isEmpty()) {
            attributes[`${key}_${value.idAttribute}`] = value.id;
          }
          delete attributes[key];
        }
      }, this)
    );

    if (this.jsonAttributes) {
      return _.pick(attributes, this.jsonAttributes);
    }
    return attributes;
  }
});



// WEBPACK FOOTER //
// ./src/extensions/relational-model.js